import React, { useState } from 'react';
import './simpletaxcalculator.css'
import axios from 'axios';
import { API_BASE_URL, NGROK_URL } from '../../utils/const';

const SimpleTaxCalculatorForm = () => {
  const [formData, setFormData] = useState({
    incomeYear: '',
    residencyStatus: '',
    taxableIncome: '',
    partTimeDuration: '',
  });

  const [isThinking, setIsThinking] = useState(false);
  const [taxResult, setTaxResult] = useState(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    setIsThinking(true); // Show loader
    setTaxResult(null); // Clear previous results
    
    try {
      const postData = {
        financial_year: formData.incomeYear,
        taxable_income: Number(formData.taxableIncome),
        residency_status: formData.residencyStatus,
        resident_months: formData.residencyStatus === "Part-year resident" ? +formData.partTimeDuration : null,
      }
      
      const response = await axios.post(API_BASE_URL+"/ato_calculator/calculate-simple_tax_calculator", postData);
      const data = response.data;
      setTaxResult(data.calculated_tax);
      console.log('API Response:', data);
      
      // Reset form after submission
      setFormData({
        incomeYear: '',
        residencyStatus: '',
        taxableIncome: '',
        partTimeDuration: '',
      });
    } catch (error) {
      console.error('Error calculating tax:', error);
      // Optionally show error message to user
    } finally {
      setIsThinking(false); // Hide loader
    }
  };

  return (
    <div className="form-container py-5">
    <form className="p-4 border rounded bg-white shadow-sm" onSubmit={handleSubmit}>
      <h1 className="mb-3 text-primary">Simple Tax Calculator</h1>
      <p className="note">All fields marked with * are mandatory</p>
  
      <div className="form-group">
        <label className="form-label">Income Year *</label>
        <select className="form-select" name="incomeYear" value={formData.incomeYear} onChange={handleChange}>
          <option value="">Select</option>
          <option value="2013-14">2013–14</option>
            <option value="2014-15">2014–15</option>
            <option value="2015-16">2015–16</option>
            <option value="2016-17">2016–17</option>
            <option value="2017-18">2017–18</option>
            <option value="2018-19">2018–19</option>
            <option value="2019-20">2019–20</option>
            <option value="2020-21">2020–21</option>
            <option value="2021-22">2021–22</option>
            <option value="2022-23">2022–23</option>
            <option value="2023-24">2023–24</option>
        </select>
      </div>
  
     
  
      <div className="form-group">
        <label className="form-label">Taxable Income *</label>
        <div className="input-group">
          <span>$</span>
          <input
            type="number"
            className="form-control"
            name="taxableIncome"
            value={formData.taxableIncome}
            onChange={handleChange}
            placeholder="Enter your income"
          />
        </div>
      </div>

      <div className="form-group">
  <label className="form-label">Select your residency status *</label>
  <div className="residency-options">
    <div className={`residency-option ${formData.residencyStatus === "Resident for full year" ? "selected" : ""}`}>
      <input
        type="radio"
        className="form-check-input"
        id="resident"
        name="residencyStatus"
        value="Resident for full year"
        checked={formData.residencyStatus === "Resident for full year"}
        onChange={handleChange}
      />
      <label className="form-check-label" htmlFor="resident">Resident for full year</label>
    </div>
    <div className={`residency-option ${formData.residencyStatus === "Non-resident for full year" ? "selected" : ""}`}>
      <input
        type="radio"
        className="form-check-input"
        id="non-resident"
        name="residencyStatus"
        value="Non-resident for full year"
        checked={formData.residencyStatus === "Non-resident for full year"}
        onChange={handleChange}
      />
      <label className="form-check-label" htmlFor="non-resident">Non-resident for full year</label>
    </div>
    <div className={`residency-option ${formData.residencyStatus === "Part-year resident" ? "selected" : ""}`}>
      <input
        type="radio"
        className="form-check-input"
        id="part-time-resident"
        name="residencyStatus"
        value="Part-year resident"
        checked={formData.residencyStatus === "Part-year resident"}
        onChange={handleChange}
      />
      <label className="form-check-label" htmlFor="part-time-resident">Part-year resident</label>
    </div>
  </div>
</div>

{/* Conditionally render the duration dropdown if "Part-Time Resident" is selected */}
{formData.residencyStatus === "Part-year resident" && (
  <div className="form-group">
    <label className="form-label">Select Duration *</label>
    <select
      className="form-select"
      name="partTimeDuration"
      value={formData.partTimeDuration || ""}
      onChange={handleChange}
    >
      <option value="">Select</option>
  <option value="1">1</option>
  <option value="2">2</option>
  <option value="3">3</option>
  <option value="4">4</option>
  <option value="5">5</option>
  <option value="6">6</option>
  <option value="7">7</option>
  <option value="8">8</option>
  <option value="9">9</option>
  <option value="10">10</option>
  <option value="11">11</option>
    </select>
  </div>
)}
  
      {/* <div className="form-group">
        <label className="form-label">Tax Withheld</label>
        <input
          type="number"
          className="form-control"
          name="taxWithheld"
          value={formData.taxWithheld}
          onChange={handleChange}
          placeholder="Optional"
        />
      </div>
  
      <div className="form-group">
        <label className="form-label">Medicare Levy *</label>
        <select className="form-select" name="medicareLevy" value={formData.medicareLevy} onChange={handleChange}>
          <option value="">Select</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div> */}
  
      {/* <div className="form-group">
        <label className="form-label">Medicare Levy Reduction</label>
        <select className="form-select" name="medicareReduction" value={formData.medicareReduction} onChange={handleChange}>
          <option value="">Select</option>
          <option value="full">Full</option>
          <option value="half">Half</option>
          <option value="none">None</option>
        </select>
      </div>
  
      <div className="form-group">
        <label className="form-label">Medicare Levy Exemption</label>
        <select className="form-select" name="medicareExemption" value={formData.medicareExemption} onChange={handleChange}>
          <option value="">Select</option>
          <option value="full">Full</option>
          <option value="half">Half</option>
          <option value="none">None</option>
        </select>
      </div>
  
      <div className="form-group">
        <label className="form-label">Private Health Insurance</label>
        <select className="form-select" name="privateHealthInsurance" value={formData.privateHealthInsurance} onChange={handleChange}>
          <option value="">Select</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div>
  
      <div className="form-group">
        <label className="form-label">Spouse Tax Offset</label>
        <select className="form-select" name="spouseRebate" value={formData.spouseRebate} onChange={handleChange}>
          <option value="">Select</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div>
  
      <div className="form-group">
        <label className="form-label">Low Income Tax Offset</label>
        <select className="form-select" name="lowIncomeTaxOffset" value={formData.lowIncomeTaxOffset} onChange={handleChange}>
          <option value="">Select</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div>
  
      <div className="form-group mb-4">
        <label className="form-label">Student Loan</label>
        <select className="form-select" name="studentLoan" value={formData.studentLoan} onChange={handleChange}>
          <option value="">Select</option>
          <option value="help">HELP</option>
          <option value="hecs">HECS</option>
          <option value="none">None</option>
        </select>
      </div> */}

      <div>
        {isThinking ? (
          <div className="loader"></div>
        ) : (
          taxResult && <>
          <h2 className="mb-3">Tax Calculation</h2>
          <h2>{taxResult}</h2></>
        )}
      </div>
  
      <button type="submit" >Submit</button>
    </form>
  </div>
  
  );
};

export default SimpleTaxCalculatorForm;
